module.exports = __webpack_public_path__ + "img/avatar-default.d75d62c9.png";